import { ImgHTMLAttributes } from 'react'

export default (props: ImgHTMLAttributes<HTMLImageElement>) => (
  <div
    className="flex justify-center align-middle"
    style={{ height: '50px', width: '100px' }}>
    <img className="object-contain light:hidden" {...props} />
  </div>
)
